import React from 'react';

const PageRefreshIndicator = () => {
  // Simplified - no visual indicator to avoid conflicts
  return null;
};

export default PageRefreshIndicator;
